'use strict';

const NumberUtils = require('utils/NumberUtils'),
    get = require('lodash/object').get,
    {t} = require('services/i18nextWrapper'),
    InventoryServiceImpl = require('services/InventoryServiceImpl');

const LocationStore = {


    /**
     * Persist new item in the application that will be available from the dashboard.
     * @param {Object} transferInfo
     * @param {Function} success
     * @param {Function} failure
     */
    saveTransfer(transferInfo, success, failure) {
        InventoryServiceImpl.saveTransfer(transferInfo, function () {
            if (success) {
                success(this);
            }
        }, failure);
    },

    /**
     * Perform the validation needed to defined is possible and if is valid the transference.
     * @param amountOrigin
     * @param estimatedAmount
     * @param amountTransfer
     * @return {*}
     */
    isValidTransfer(amountOrigin, estimatedAmount, amountTransfer) {
        if (amountOrigin === 0) {
            return t('inventory_and_transfer_error_inline_amount_should_be_bigger_than_zero');
        }

        if (NumberUtils.isLess(amountTransfer, 0) || NumberUtils.isLess(estimatedAmount, 0)) {
            return t('inventory_and_transfer_error_inline_amount_should_be_bigger_than_zero');
        }

        if (NumberUtils.isGreater(amountTransfer, amountOrigin)) {
            return t('inventory_and_transfer_error_inline_insufficient_amount_in_location');
        }

        return ''; // transfer was success
    },

    /**
     * Perform the validation needed to defined is possible and if is valid the adjust.
     * @param locationItem
     * @param amountTransfer
     * @return {*}
     */
    isValidAdjust(locationItem, amountTransfer) {
        const amountFromAdjusts = get(locationItem, 'amount');
        const amountToTransfer = NumberUtils.toNumber(amountTransfer);

        if (amountToTransfer > amountFromAdjusts) {
            return t('inventory_and_transfer_error_inline_insufficient_amount_in_location');
        }

        return ''; // transfer was success
    },

    /**
     * Make a transference between locations from specific amounts of items,
     * and return the result of amounts between origin and destination.
     *
     * @param {String} amountOrigin         The amount of items which have the origin location
     *                                          before perform the transference.
     * @param {String} locationItemTo      The amount of items which have the destination location
     *                                          before perform the transference
     * @param {String} amountToTransfer     The amount will be transferred between locations.
     * @return {Object}
     *
     * Note: Will return the results which standardise decimal format.
     */
    transfer(amountOrigin, amountDestination, amountToTransfer) {

        const amountTransferStandardise = NumberUtils.standardiseDecimalFormatNumber(amountToTransfer);
        const remainingAmountOrigin = NumberUtils.subtract(NumberUtils.standardiseDecimalFormatNumber(amountOrigin), amountTransferStandardise);
        const updateAmountDestination = NumberUtils.sum(NumberUtils.standardiseDecimalFormatNumber(amountDestination), amountTransferStandardise);

        return {
            locationItemAmountFrom: String(remainingAmountOrigin),
            locationItemAmountTo: String(updateAmountDestination),
            amountToTransfer: String(amountToTransfer)
        };
    }
};

module.exports = LocationStore;



/** WEBPACK FOOTER **
 ** ./src/stores/LocationStore.js
 **/